import { Map, List } from 'immutable'

/** A function to re-create a submit-able request for offers, from
 * an OfferResponse. */
const offerResponseToRequest = (res = Map()) =>
    Map.of(
        'company', res.getIn(['company']),
        'participants', res.getIn(['participants']),
        'required', res.getIn(['offerGroup'], List())
            .reduce((ogs, og = Map()) =>
                ogs.concat(
                    og.get('requested', List())
                ), List())
    )

export default offerResponseToRequest



// WEBPACK FOOTER //
// ./src/ndc/request/offerResponseToRequest.js